import http from '@api/http';
import { takeLatest, put, call } from 'redux-saga/effects';
import {
  LIST, CREATE, UPDATE, DELETE,
} from './types';
import {
  listDone, createDone, updateDone, delDone,
} from './actions';

function* list() {
  let resp;
  let err;
  try {
    resp = yield call(() => http.get('/apps'));
  } catch (ex) {
    err = ex;
  } finally {
    yield put(listDone(err, resp));
  }
}

function* create(action) {
  const { cb } = action;
  let { payload: app } = action;
  let err;
  try {
    app = yield call(() => http.post('/apps', app));
  } catch (ex) {
    err = ex;
  } finally {
    yield put(createDone(err, app));
    if (cb) {
      yield call(cb, err, app);
    }
  }
}

function* update(action) {
  const { cb } = action;
  let { payload: app } = action;
  let err;
  try {
    const resp = yield call(() => http.post(`/apps/${app.clientId}`, app));
    app = { ...app, ...resp };
  } catch (ex) {
    err = ex;
  } finally {
    yield put(updateDone(err, app));
    if (cb) {
      yield call(cb, err, app);
    }
  }
}

function* del(action) {
  const { cb } = action;
  let { payload: app } = action;
  let err;
  try {
    app = yield call(() => http.delete(`/apps/${app.clientId}`));
  } catch (ex) {
    err = ex;
  } finally {
    yield put(delDone(err, app));
    if (cb) {
      yield call(cb, err, app);
    }
  }
}

function* watchList() {
  yield takeLatest(LIST, list);
}

function* watchCreate() {
  yield takeLatest(CREATE, create);
}

function* watchUpdate() {
  yield takeLatest(UPDATE, update);
}

function* watchDelete() {
  yield takeLatest(DELETE, del);
}

export default [
  watchList,
  watchCreate,
  watchUpdate,
  watchDelete,
];
